import React, { useEffect } from 'react';
import { get, isEmpty, isNil } from 'lodash';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { injectIntl, IntlShape } from 'react-intl';
import { Container } from 'containers/LawyerLegalProceedingsPage/judgementAdd/styled-components';
import AppealAddPronouncing from 'containers/LawyerLegalProceedingsPage/AppealAdd/AppealAddPronouncing/index';
import { EMPTY_INVOICE_INFO, PROCEDURE_STEPS } from 'containers/data-structure';
import { isAllValuesIsNil } from 'helpers/utils';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import IncomeCertificatesRecap from 'containers/common/LegalProceedings/JudgementAdd/Recap/IncomeCertificatesRecap/index';
import { JudgementADDDocumentType } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { Vehicule } from 'containers/PreOpeningPage/typings.d';
import { Listings } from 'containers/AppContainer/typings';
import { Idetails } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/typings';
import InvoiceInfoDialog from 'components/InvoiceFeeNoteDialog/InvoiceInfoDialog';
import currentUserStorage from 'containers/services/security/current-user-storage';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerLegalProceedingsPage/AppealAdd/messages';
import ProcedureInformation from 'containers/LawyerLegalProceedingsPage/judgementAdd/ProcedureInformation';
import { AppealAddDocType } from 'containers/LawyerLegalProceedingsPage/AppealAdd/constants';
import JudgementValidationButtons from 'containers/common/LegalProceedings/JudgementValidationButtons';
import { PAGES } from 'routes';
import { pushTo } from 'containers/services/routes-helper';
import { PROCEDURE_TYPES } from 'containers/LawyerLegalProceedingsPage/constants';
import * as utils from 'containers/LawyerLegalProceedingsPage/AppealAdd/utils';
import SuccessDialog from 'components/SuccessDialog';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { formatInvoiceFeeNoteInfos } from 'containers/LawyerLegalProceedingsPage/utils';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import { isUserActive } from 'containers/common/LegalProceedings/utils';
import FirmReferenceForm from 'components/FirmReferenceForm';
import withLoading from 'containers/AppContainer/withLoading';
import { LOADERS } from 'containers/AppContainer/Loader/constants';
import {
  formatCourtFileNumber,
  getVictimsIncome,
  validationCourtFileNumber,
} from 'containers/LawyerLegalProceedingsPage/judgementAdd/utils';
import moment from 'moment-timezone';
import { resolveJudiciaryProcessType } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import {
  extractIntervenant,
  formatIntervenants,
} from 'containers/RecapPage/utils';
import InvoiceFeeNoteDialog from 'components/InvoiceFeeNoteDialog';
import DynamiqDialog from 'components/InvoiceFeeNoteDialog/DynamiqDialog';
import InvoiceFeeNotesManagerDialog from 'components/InvoiceFeeNoteDialog/InvoiceFeeNotesManagerDialog';
import { getValueByCode } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import IncomeCertificate from 'containers/LawyerLegalProceedingsPage/judgementAdd/IncomeCertificate';
import { hasIncomeCertificate } from 'containers/LawyerLegalProceedingsPage/judgementAdd/IncomeCertificate/utils';
import { isBlockStatusClaim } from 'containers/CourtManagerLegalProceedings/utils';
import { VictimType } from 'typings/globalTypes';
import {
  getLimitInvoiceIntervenant,
  getLimitInvoiceManager,
} from 'services/utils';
import { Typography } from '@material-ui/core';
export interface FormsADDProps {
  intl: IntlShape;
  victims: VictimType[];
  listings: Listings;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  vehicules: Vehicule[];
  resetUploadedDocument: Function;
  details: Idetails;
  judgementAddDocuments: JudgementADDDocumentType[];
  setDetails: Function;
  setJudgementAddDocuments: Function;
  canStartJudgementAdd: boolean;
  canValidateJudgementAddProcedure: boolean;
  setDocumentId: Function;
  document: AppealAddDocType;
  documentId: any;
  setDocument: Function;
  claimId: number;
  claimNumber: string;
  requestCreateJudgementAdd: Function;
  policyInfo: any;
  judiciaryProcessId: number;
  processInformationValidation?: any;
  messageError?: any;
  currentJudiciaryProcess: any;
  isCivilProceeding: boolean;
  setDialogOpenFirmReference?: Function;
  loaders: any;
  isManager: boolean;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  setIsButtonRedirect?: Function;
  feeNotes: any;
  setOpenFeeNoteDialog: Function;
  requestCreateIncomeCertificate: Function;
  requestUpdateIncomeCertificate: Function;
  requestMakeDecisionIncomeCertificate: Function;
  isConsultation: boolean;
  riskKey: string;
  imagineDocuments: any;
  dahirAmount: [];
  civilDocumentsVictims?: [];
  requestGetDocByDocumentumId: Function;
}

const FormsADD: React.FC<FormsADDProps> = (props): JSX.Element => {
  const [isSuccessPopinOpen, setIsSuccessPopinOpen] = React.useState<boolean>(
    false,
  );
  const [invoiceFeeNoteInfos, setInvoiceFeeNoteInfo] = React.useState<any>([]);
  const [generateFeeNoteLawyer, setGenerateFeeNoteLawyer] = React.useState<
    boolean
  >(false);
  const [lawyerFirmRef, setLawyerFirmRef] = React.useState(null);
  const [openInvoiceInfoLawyers, setOpenInvoiceInfoLawyers] = React.useState<
    boolean
  >(false);
  const [
    decisionGenerationFeeNote,
    setDecisionGenerationFeeNote,
  ] = React.useState(null);
  const [
    openInvoiceFeeNoteInfoDialog,
    setOpenInvoiceFeeNoteInfoDialog,
  ] = React.useState(false);
  const [invoiceDocument, setInvoiceDocument] = React.useState({});
  const [invoiceNumber, setInvoiceNumber] = React.useState(null);
  const [invoiceDate, setInvoiceDate] = React.useState(null);
  const claimAssignment = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'claim', 'assignment'], []),
  );
  const claim = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap'], []),
  );
  const assignedLawyersByJudiciaryProcess = claimAssignment.filter(
    (el: any) =>
      el.judiciaryProcessId === props.judiciaryProcessId &&
      el.isDeleted === false,
  );

  const lawyerAssignment = claimAssignment.find(
    (el: any) =>
      el.assignedLawyer === currentIntervenantStorage.get()?.sagis_code &&
      el.judiciaryProcessId === props.judiciaryProcessId &&
      el.isDeleted === false,
  );

  const lawyerFirmReference = get(lawyerAssignment, 'firmReference', null);

  const onValidate = () => {
    if (isEmpty(props.judgementAddDocuments)) createAppealAdd(false);
    else {
      !props.isManager
        ? setIsSuccessPopinOpen(true)
        : !isEmpty(
            extractIntervenant(
              get(props.listings, 'intervenants'),
              assignedLawyersByJudiciaryProcess,
            ),
          )
        ? setGenerateFeeNoteLawyer(true)
        : createAppealAdd(true);
    }
  };
  useEffect(() => {
    if (props.isManager) {
      if (
        !isEmpty(
          extractIntervenant(
            get(props.listings, 'intervenants'),
            assignedLawyersByJudiciaryProcess,
          ),
        )
      ) {
        setInvoiceFeeNoteInfo(
          extractIntervenant(
            get(props.listings, 'intervenants'),
            assignedLawyersByJudiciaryProcess,
          ).map((item: any, index: any) => ({
            codeIntervenant: item.ItemKey,
            createdBy:
              currentUserStorage?.get() && currentUserStorage?.get().username,
            ...EMPTY_INVOICE_INFO,
          })),
        );
      }
    }
  }, [
    !claimAssignment,
    props.judiciaryProcessId,
    props.currentJudiciaryProcess,
  ]);
  const lawyerInfo = {
    code:
      currentIntervenantStorage.get() &&
      currentIntervenantStorage.get().sagis_code,
    name:
      currentIntervenantStorage.get() && currentIntervenantStorage.get().name,
  };

  const createAppealAdd = (withFeeNote: boolean) => {
    const judgementAdd = utils.judgementAddFormatorAppeal(
      props.claimId,
      details,
      judgementAddDocuments,
      props.listings,
      props.policyInfo,
      withFeeNote,
      props.isManager,
    );
    props.isManager &&
      props.setIsButtonRedirect &&
      props.setIsButtonRedirect(true);
    props.requestCreateJudgementAdd(
      {
        isLawyer: !props.isManager,
        judgementAdd: {
          isTrackingActive: featureService.hasFeature(
            FEATURES.TRACKING_ACTIONS_USER,
          ),
          isInboxesActive: featureService.hasFeature(
            FEATURES.ATTRIBUTION_INBOXES_MANAGER,
          ),
          ...judgementAdd,
          isLawyer: !props.isManager,
          ...(!props.isManager
            ? {
                lawyerCode:
                  currentIntervenantStorage.get() &&
                  currentIntervenantStorage.get().sagis_code,
              }
            : undefined),
          claimNumber: props.claimNumber,
          procedureType: PROCEDURE_TYPES.APPEAL,
          judiciaryProcessId: props.judiciaryProcessId,
          lawyerFirmReference: lawyerFirmRef,
          assignementId: get(lawyerAssignment, 'id'),
          isCompanyIntervenants: formatIntervenants(
            assignedLawyersByJudiciaryProcess,
          ),
          decisionGenerationFeeNote: decisionGenerationFeeNote,
          invoiceFeeNoteInfos:
            withFeeNote &&
            props.isManager &&
            !isEmpty(invoiceFeeNoteInfos) &&
            featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE)
              ? formatInvoiceFeeNoteInfos(invoiceFeeNoteInfos)
              : [],
          feeNote: withFeeNote
            ? {
                step: PROCEDURE_STEPS.ARRET_ADD,
                ...(!props.isManager
                  ? { codeIntervenant: lawyerInfo.code }
                  : undefined),
                judgementDate: get(
                  judgementAddDocuments,
                  '[0].judgementDate',
                  '',
                ),
                judiciaryProcessId: props.judiciaryProcessId,
                firmReference: isNil(lawyerFirmReference)
                  ? lawyerFirmRef
                  : lawyerFirmReference,
                courtNumber: `${resolveJudiciaryProcessType(
                  get(props.currentJudiciaryProcess, 'procedureNatureId'),
                )} ${formatCourtFileNumber(get(details, 'courtFile'))}`,
                invoiceFeeNote:
                  featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) &&
                  !isAllValuesIsNil({
                    invoiceNumber: invoiceNumber,
                    invoiceDate: invoiceDate,
                    ...invoiceDocument,
                  })
                    ? {
                        codeIntervenant: lawyerInfo.code,
                        createdBy:
                          currentIntervenantStorage?.get() &&
                          currentIntervenantStorage?.get()?.preferred_username,
                        invoiceNumber: invoiceNumber,
                        invoiceDate:
                          invoiceDate === 'Invalid date' ? null : invoiceDate,
                        receptionDate: moment().format('YYYY-MM-DD'),
                        ...invoiceDocument,
                        isIndexed: false,
                      }
                    : undefined,
              }
            : undefined,
        },
        isLawyerInboxesActive: featureService.hasFeature(
          FEATURES.LAWYER_INBOXES,
        ),
      },
      successCallback(withFeeNote),
    );
  };

  const handleClick = () => {
    createAppealAdd(true);
  };

  const successCallback = (withFeeNote: boolean) => () => {
    toast.success(translate(messages.successToastTitle, props));
    withFeeNote && !props.isManager
      ? pushTo(PAGES.FEE_NOTE)()
      : !props.isManager && !withFeeNote && pushTo(PAGES.LAWYER_ASSIGNMENTS)();
  };

  const doNotGenerateFeeNote = () => createAppealAdd(false);

  const handleOpenInvoicesInfoDialog = () => {
    setIsSuccessPopinOpen(false);
    setOpenInvoiceFeeNoteInfoDialog(true);
  };

  const handleCloseSuccessDialog = () => {
    setIsSuccessPopinOpen(false);
    doNotGenerateFeeNote();
  };

  const handleCloseInvoiceFeeNote = () => {
    setOpenInvoiceFeeNoteInfoDialog(false);
  };

  const handleValidateInvoice = () => {
    handleClick();
    setOpenInvoiceFeeNoteInfoDialog(false);
  };

  const handleOpenInvoicesInfoLawyersDialog = () => {
    setGenerateFeeNoteLawyer(false);
    setOpenInvoiceInfoLawyers(true);
  };

  const {
    details,
    judgementAddDocuments,
    listings,
    victims,
    vehicules,
    uploadDocument,
    uploadedDocument,
    resetUploadedDocument,
    setDetails,
    setJudgementAddDocuments,
    processInformationValidation,
    messageError,
  } = props;

  const currentlawyerAssignment =
    claimAssignment.find(
      (el: any) =>
        el.judiciaryProcessId === props.judiciaryProcessId &&
        el.isDeleted === false,
    ) || {};
  return (
    <Container id="add-bloc">
      {props.isManager && (
        <div style={{ fontWeight: 'bold', fontSize: '18px', color: 'red' }}>
          {!isUserActive(
            props.listings,
            get(currentlawyerAssignment, 'assignedLawyer'),
          ) &&
          !isEmpty(currentlawyerAssignment) &&
          !isEmpty(props.listings)
            ? translate(messages.userNotValidWarning, props, {
                lawyerName: getValueByCode(
                  get(currentlawyerAssignment, 'assignedLawyer', ''),
                  get(props.listings, 'inactiveIntervenants', []),
                ),
              })
            : ''}
        </div>
      )}
      {lawyerAssignment &&
        !isBlockStatusClaim(props.policyInfo) &&
        !props.isManager && (
          <FirmReferenceForm
            firmReference={lawyerFirmReference}
            message={
              lawyerFirmReference === null
                ? translate(messages.lawyerFirmReferenceUpdateMessage, props)
                : translate(messages.lawyerFirmReferenceEditMessage, props)
            }
            formInputLabel={translate(
              messages.lawyerFirmReferenceDialogLabel,
              props,
            )}
            formInputName={translate(
              messages.lawyerFirmReferenceDialogLabel,
              props,
            )}
            validationButtonTitle={
              lawyerFirmReference === null
                ? translate(messages.saveButton, props)
                : translate(messages.editButton, props)
            }
            setIsDialogOpenFirmReference={props.setDialogOpenFirmReference}
            isFeeNoteGenerated={false}
            isForm
            judiciaryProcessId={props.judiciaryProcessId}
            assignment={lawyerAssignment}
            lawyerFirmReference={lawyerFirmReference}
          />
        )}
      <ProcedureInformation
        listings={listings}
        details={details}
        vehicules={vehicules}
        setDetails={setDetails}
        processInformationValidation={processInformationValidation}
        messageError={messageError}
        lossDate={get(claim, 'claim.lossDate')}
        sagisOpposingParties={props.sagisOpposingParties}
        currentJudiciaryProcess={props.currentJudiciaryProcess}
      />
      <AppealAddPronouncing
        judgementAddDocuments={judgementAddDocuments}
        setJudgementAddDocuments={setJudgementAddDocuments}
        listings={listings}
        document={props.document}
        setDocument={props.setDocument}
        victims={victims}
        details={details}
        vehicules={vehicules}
        uploadDocument={uploadDocument}
        uploadedDocument={uploadedDocument}
        resetUploadedDocument={resetUploadedDocument}
        disabled={!props.canStartJudgementAdd}
        judiciaryProcessId={props.judiciaryProcessId}
        sagisVictimInfo={props.sagisVictimInfo}
        sagisOpposingParties={props.sagisOpposingParties}
        claimAssignment={claimAssignment}
        feeNotes={props.feeNotes}
        setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
        imagineDocuments={props.imagineDocuments}
        claimId={props.claimId}
        policyInfo={props.policyInfo}
        requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
      />
      <JudgementValidationButtons
        onValidation={onValidate}
        onCancel={pushTo(PAGES.LAWYER_ASSIGNMENTS)}
        isValidationDisabled={
          !props.canValidateJudgementAddProcedure ||
          !validationCourtFileNumber(details.courtFile)
        }
      />
      {!userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMONITORINGMANAGER) &&
      featureService.hasFeature(FEATURES.INCOME_CERTIFICATE) &&
      !isEmpty(props.currentJudiciaryProcess) &&
      !isEmpty(
        getVictimsIncome(
          props.isCivilProceeding,
          props.currentJudiciaryProcess,
          props.civilDocumentsVictims
            ? props.civilDocumentsVictims
            : ({} as any),
          props.victims,
          claim,
        ),
      ) &&
      !hasIncomeCertificate(
        getVictimsIncome(
          props.isCivilProceeding,
          props.currentJudiciaryProcess,
          props.civilDocumentsVictims
            ? props.civilDocumentsVictims
            : ({} as any),
          props.victims,
          claim,
        ),
      ) ? (
        <IncomeCertificate
          victims={getVictimsIncome(
            props.isCivilProceeding,
            props.currentJudiciaryProcess,
            props.civilDocumentsVictims
              ? props.civilDocumentsVictims
              : ({} as any),
            props.victims,
            claim,
          )}
          uploadDocument={uploadDocument}
          uploadedDocument={uploadedDocument}
          resetUploadedDocument={resetUploadedDocument}
          sagisVictimInfo={props.sagisVictimInfo}
          requestCreateIncomeCertificate={props.requestCreateIncomeCertificate}
          isManager={userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER)}
          setDocumentId={props.setDocumentId}
          documentId={props.documentId}
          claimId={props.claimId}
          claimNumber={props.claimNumber}
          judiciaryProcessId={props.judiciaryProcessId}
          dahirAmount={props.dahirAmount}
          claim={claim}
          riskKey={props.riskKey}
          listings={props.listings}
        />
      ) : hasIncomeCertificate(
          getVictimsIncome(
            props.isCivilProceeding,
            props.currentJudiciaryProcess,
            props.civilDocumentsVictims
              ? props.civilDocumentsVictims
              : ({} as any),
            props.victims,
            claim,
          ),
        ) ? (
        <IncomeCertificatesRecap
          victims={getVictimsIncome(
            props.isCivilProceeding,
            props.currentJudiciaryProcess,
            props.civilDocumentsVictims
              ? props.civilDocumentsVictims
              : ({} as any),
            props.victims,
            claim,
          )}
          sagisVictimInfo={props.sagisVictimInfo}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          resetUploadedDocument={props.resetUploadedDocument}
          requestCreateIncomeCertificate={props.requestCreateIncomeCertificate}
          requestUpdateIncomeCertificate={props.requestUpdateIncomeCertificate}
          isManager={userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER)}
          setDocumentId={props.setDocumentId}
          documentId={props.documentId}
          claimNumber={props.claimNumber}
          claimId={props.claimId}
          judiciaryProcessId={props.judiciaryProcessId}
          readOnly={false}
          requestMakeDecisionIncomeCertificate={
            props.requestMakeDecisionIncomeCertificate
          }
          isConsultation={props.isConsultation}
          riskKey={props.riskKey}
          claim={claim}
          judgementAdd={{}}
          dahirAmount={props.dahirAmount}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          listings={props.listings}
        />
      ) : (
        <></>
      )}

      {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) &&
      !props.isManager ? (
        <InvoiceFeeNoteDialog
          open={isSuccessPopinOpen}
          onClose={() => setIsSuccessPopinOpen(false)}
          decisionGenerationFeeNote={decisionGenerationFeeNote}
          setDecisionGenerationFeeNote={setDecisionGenerationFeeNote}
          handleValidate={
            decisionGenerationFeeNote
              ? handleOpenInvoicesInfoDialog
              : handleCloseSuccessDialog
          }
          shouldDisplayFirmReferenceField={
            isEmpty(lawyerFirmReference) && !props.isManager
          }
          setLawyerFirmRef={setLawyerFirmRef}
          lawyerFirmRef={lawyerFirmRef}
        />
      ) : (
        <SuccessDialog
          title={translate(messages.successDialogTitle, props)}
          secondaryButtonTitle={translate(
            messages.successDialogSecondaryButtonTitle,
            props,
          )}
          primaryButtonTitle={
            featureService.hasFeature(FEATURES.FEE_NOTE)
              ? translate(messages.successDialogPrimaryButtonTitleJdd, props)
              : translate(messages.successDialogPrimaryButtonTitle, props)
          }
          tertiaryButtonTitle={translate(
            { ...messages.doNotGenerateFeeNote },
            props,
          )}
          onTertiaryClick={doNotGenerateFeeNote}
          open={isSuccessPopinOpen}
          onClose={setIsSuccessPopinOpen}
          homePath={PAGES.LAWYER_HOME}
          isExpertReport={false}
          onPrimaryClick={handleClick}
          isPrimaryButtonDisabled={isEmpty(lawyerFirmReference)}
        />
      )}
      {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) && (
        <InvoiceInfoDialog
          open={openInvoiceFeeNoteInfoDialog}
          onClose={handleCloseInvoiceFeeNote}
          handleValidate={handleValidateInvoice}
          invoiceNumber={invoiceNumber}
          invoiceDate={invoiceDate}
          setInvoiceNumber={setInvoiceNumber}
          setInvoiceDate={setInvoiceDate}
          resetUploadedDocument={resetUploadedDocument}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          invoiceDocument={invoiceDocument}
          setInvoiceDocument={setInvoiceDocument}
          limitInvoiceDate={getLimitInvoiceIntervenant(
            get(props.listings, 'appConfig', []),
          )}
        />
      )}
      {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) &&
        props.isManager && (
          <InvoiceFeeNoteDialog
            open={generateFeeNoteLawyer}
            onClose={() => setGenerateFeeNoteLawyer(false)}
            decisionGenerationFeeNote={decisionGenerationFeeNote}
            setDecisionGenerationFeeNote={setDecisionGenerationFeeNote}
            handleValidate={
              decisionGenerationFeeNote
                ? handleOpenInvoicesInfoLawyersDialog
                : handleCloseSuccessDialog
            }
            shouldDisplayFirmReferenceField={
              isEmpty(lawyerFirmReference) && !props.isManager
            }
            setLawyerFirmRef={setLawyerFirmRef}
            lawyerFirmRef={lawyerFirmRef}
          />
        )}
      {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) && (
        <DynamiqDialog
          open={openInvoiceInfoLawyers}
          onClose={() => setOpenInvoiceInfoLawyers(false)}
          handleValidate={() => {
            createAppealAdd(true);
            setOpenInvoiceInfoLawyers(false);
          }}
          children={
            <>
              {extractIntervenant(
                get(props.listings, 'intervenants'),
                assignedLawyersByJudiciaryProcess,
              ).map((item: any, index: any) => (
                <div style={{ marginTop: 10 }}>
                  <Typography style={{ fontWeight: 700 }}>
                    {translate(messages.intervenantName, props, {
                      IntervenantName: get(item, 'ItemDescription', null),
                    })}
                  </Typography>
                  <InvoiceFeeNotesManagerDialog
                    invoiceFeeNoteInfo={invoiceFeeNoteInfos[index]}
                    listings={listings}
                    invoiceFeeNoteInfos={invoiceFeeNoteInfos}
                    resetUploadedDocument={resetUploadedDocument}
                    uploadedDocument={uploadedDocument}
                    uploadDocument={uploadDocument}
                    assignedLawyersByJudiciaryProcess={
                      assignedLawyersByJudiciaryProcess
                    }
                    setDocumentId={props.setDocumentId}
                    setInvoiceFeeNoteInfo={setInvoiceFeeNoteInfo}
                    index={index}
                    displayFirmReferenceInput={
                      isNil(get(item, 'firmReference', null)) &&
                      featureService.hasFeature(FEATURES.LIMIT_INVOICE_DATE)
                    }
                    documentId={props.documentId}
                    limitInvoiceDate={getLimitInvoiceManager(
                      get(props.listings, 'appConfig', []),
                    )}
                  />
                </div>
              ))}
            </>
          }
        />
      )}
    </Container>
  );
};

export default injectIntl(withLoading(FormsADD, [LOADERS.JUDGEMENT_ADD]));
